<template>
  <div class="ap-view-message">
    <div class="page-list" v-show="!$route.params.id">
      <div style="height: 56px">
        <div class="title float-left">系统通知</div>
        <div class="fast-group">
          <div class="fast-item" :class="type == 'all' ? 'active' : ''" @click="type = 'all'">所有</div>
          <div class="fast-item" :class="type == 'unRead' ? 'active' : ''" @click="type = 'unRead'">未读</div>
          <div class="fast-item" :class="type == 'read' ? 'active' : ''" @click="type = 'read'">已读</div>
        </div>
        <div class="float-right">
          <el-button size="small" style="padding: 7px 15px" v-if="profile.id && !profile.wechatId" @click="bindWeChat">
            <img style="height: 16px; vertical-align: sub" src="@assets/icons/wx.png" />&nbsp;绑定微信通知
          </el-button>
          <el-button size="small" @click="readAll">全部设为已读</el-button>
        </div>
      </div>
      <div class="message">
        <ul style="min-height: 50px" v-loading="loading">
          <li class="clearfix" v-for="it in msgList" :key="it.id" :class="{ active: !it.read }">
            <div class="status" @click="switchStatus(it)"></div>
            <div class="float-left cont" @click="readMsg(it)">{{ it.content }}</div>
            <div class="float-right time">{{ it.sendTime | toShortDateTime }}</div>
          </li>
        </ul>
      </div>
      <div style="margin-top: 30px">
        <Pagination :total="total" :limit="15" @page-to="getMsgList" ref="page" />
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from "@components/Pagination.vue";

export default {
  components: {
    Pagination,
  },
  data() {
    return {
      showBingWx: false,
      type: "all",
      total: 0,
      msgList: [],
      profile: {},
      loading: false,
    };
  },
  watch: {
    type() {
      this.$refs.page.pageIndex = 1;
      this.getMsgList();
    },
  },
  created() {
    this.getMsgList();
    this.getProfile();
  },
  methods: {
    bindWeChat() {
      const passportUrl = process.env.VUE_APP_PASSPORT_URL;
      let uri = `${passportUrl}/#/login?redirectUrl=${encodeURIComponent(location.href + "?phone=") + this.profile.userPrincipals[0].principal}`;
      window.location.replace(uri);
    },
    getMsgList(args) {
      if (this.type == "unRead") var read = false;
      if (this.type == "read") var read = true;
      this.loading = true;
      this.$post("/shared/notification/query", {
        limit: args ? args.limit : 15,
        offset: args ? args.offset : 0,
        criteria: {
          // keyword: this.searchText,
          type: "M2B",
          read,
        },
      })
        .then((res) => {
          this.loading = false;
          this.total = res.total;
          this.msgList = res.results;
        })
        .catch((err) => {});
    },
    readMsg(it) {
      if (!it.read) {
        this.$get("/shared/notification/read/" + it.id)
          .then(() => {
            this.$root.eventBus.$emit("refreshMsgCount");
            this.$refs.page.refresh();
          })
          .catch((err) => {});
      }
      if (it.type == "ORDER") {
        window.open("#/buyer/order/" + it.refId, "_blank");
      }
    },
    readAll() {
      this.$post("/shared/notification/read/all")
        .then(() => {
          this.$root.eventBus.$emit("refreshMsgCount");
          this.$refs.page.refresh();
        })
        .catch((err) => {});
    },
    switchStatus(it) {
      if (it.read === true) var url = "/shared/notification/unread/batch";
      if (it.read === false) var url = "/shared/notification/read/batch";
      this.$post(url, { ids: it.id })
        .then(() => this.$refs.page.refresh())
        .catch((err) => {});
    },
    getProfile() {
      this.$get("/spms/myProfiles/getProfile")
        .then((res) => (this.profile = res))
        .catch((err) => {});
    },
  },
};
</script>

<style lang="less">
.ap-view-message {
  padding: 20px;
  background: #fff;
  .title {
    margin: 0 20px 20px 0;
    font-size: 24px;
  }
  .fast-group {
    margin-top: 4px;
  }
  .message {
    li {
      padding: 6px;
      color: #999;
      font-size: 12px;
      font-weight: normal;
      border-bottom: 1px solid rgba(34, 34, 48, 0.1);
      &:last-child {
        border: none;
      }
      &.active {
        .status {
          background: #00cc47;
        }
      }
      .cont {
        padding: 6px;
        cursor: pointer;
        &:hover {
          text-decoration: underline;
        }
      }
      .status {
        border-radius: 50%;
        background: #ccc;
        margin-top: 9px;
        margin-right: 9px;
        width: 12px;
        height: 12px;
        float: left;
        &:hover {
          transform: scale(1.2);
          cursor: pointer;
        }
      }
      .time {
        padding: 6px;
      }
    }
  }
}
</style>